export const REVIEW_RUN_OBJECTIVES_LOAD = 'REVIEW_RUN_OBJECTIVES_LOAD'
export const REVIEW_RUN_OBJECTIVES_LOAD_PENDING = 'REVIEW_RUN_OBJECTIVES_LOAD_PENDING'
export const REVIEW_RUN_OBJECTIVES_LOAD_FULFILLED = 'REVIEW_RUN_OBJECTIVES_LOAD_FULFILLED'
export const REVIEW_RUN_OBJECTIVES_LOAD_REJECTED = 'REVIEW_RUN_OBJECTIVES_LOAD_REJECTED'
